import { Component } from '@angular/core';
import { FrequencyService } from '../services/frequency.service';

@Component({
  selector: 'app-frequency-pagination',
  templateUrl: './frequency-pagination.component.html'
})
export class FrequencyPaginationComponent {
  constructor(public service: FrequencyService) { }

  onPaginate(page: number) {
    this.service.currentPage = page;
    this.service.search();
  }
}
